<ng-template>
  <div
    class="ant-dropdown"
    [class.ant-dropdown-rtl]="dir === 'rtl'"
    [ngClass]="nzOverlayClassName"
    [ngStyle]="nzOverlayStyle"
    @slideMotion
    (@slideMotion.done)="onAnimationEvent($event)"
    [@.disabled]="noAnimation?.nzNoAnimation"
    [nzNoAnimation]="noAnimation?.nzNoAnimation"
    (mouseenter)="setMouseState(true)"
    (mouseleave)="setMouseState(false)">
    <ng-content></ng-content>
  </div>
</ng-template>
